import React from 'react';
import {createFileRoute, useRouter} from '@tanstack/react-router';
import {fetchCustomerDetails} from '@/services.ts';
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query';
import {MyDetails} from '@/components/molecules/MyDetails';
import {LoadingScreen} from '@/components/molecules/LoadingScreen';
import {ACCOUNT_STALE_TIME_5_MINS} from '@/config';

const customerDetailsQueryOptions = (isServer: boolean) => queryOptions({
  queryKey: ['customerDetails'],
  queryFn: () => {
    if(isServer) {
      return null;
    }
    return fetchCustomerDetails();
  },
  staleTime: ACCOUNT_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/account/details')({
  loader: ({ context }) => context.queryClient?.ensureQueryData(customerDetailsQueryOptions(context.isServer)),
  component: MyAccount,
  pendingComponent: LoadingScreen
});

function MyAccount() {
  const router = useRouter();

  const { error, data } = useSuspenseQuery(customerDetailsQueryOptions(router.isServer));
  if(error) return (<div className="mt-5">Error!</div>);
  if(data) {
    return(
      <div>
        <h1 className="page-title">My Details</h1>
        <MyDetails customer={data} />
      </div>
    );
  }
}
